import { Hunk } from '../diff/diffMarkdown';
import { SkillChangeTargetKind } from '../escalations/skillChangeApproval';

export enum InteractiveCardType {
  COVER_RATES_COLLECTION = 'COVER_RATES_COLLECTION',
  QUICK_REPLY = 'QUICK_REPLY',
  SKILL_CHANGE_APPROVAL = 'SKILL_CHANGE_APPROVAL',
  TRACK_SETTINGS_CHANGE_APPROVAL = 'TRACK_SETTINGS_CHANGE_APPROVAL',
}

export type CardBlock =
  | { type: 'text'; text: string }
  | { type: 'markdown'; text: string }
  | { type: 'facts'; facts: { label: string; value: string }[] }
  | { type: 'diff'; label: string; text: string; hunks?: Hunk[] };

export type CardActionStyle =
  | 'default'
  | 'subtle'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'cancel'
  | 'danger';

export type CardAction = {
  verb: string;
  label: string;
  style?: CardActionStyle;
  data?: Record<string, string>;
  fallbackUrl: string;
  isInProgress?: boolean;
};

export type CardResolution = {
  outcome: string;
  byName?: string;
  at: string;
};

export type InteractiveCard = {
  cardType: InteractiveCardType;
  targetKind?: SkillChangeTargetKind;
  title?: string;
  blocks: CardBlock[];
  actions: CardAction[];
  fallbackText: string;
  resolution?: CardResolution;
};

export function formatCardResolution(resolution: CardResolution): string {
  const who = resolution.byName ? ` by ${resolution.byName}` : '';
  return `${resolution.outcome}${who}`;
}
